import http from '@/utils/http';

const baseUrl = '/rastreabilidade/nota-pesagem';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/buscar?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscar(filtros, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '?texto-busca=' + textoBusca + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas de Pesagem'
        });
    },

    buscarNotaDePesagem() {
        return http.get({
            url: baseUrl + `/buscar?filtro=`,
            lockScreen: false
        });
    },

    buscarTotalizadoresNotaDePesagem() {
        return http.get({
            url: baseUrl + `/totalizadores`,
            lockScreen: false
        });
    },

    editarNotaDePesagem(payload) {
        return http.post({
            url: baseUrl + '/editar',
            data: payload,
            lockScreen: true
        });
    },

    excluirNotaDePesagem(payload) {
        return http.post({
            url: baseUrl + '/excluir',
            data: payload,
            lockScreen: true
        });
    },

    buscarPorFazenda(codigoFazenda, paginacao) {
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl + '/buscar-por-fazenda' + '?codigo-fazenda=' + codigoFazenda + '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas de Pesagem'
        });
    },

    buscarPorNumeroEdata(codigoFazenda, filtros, dataInicio, dataFim, paginacao) {
        let textoBusca = '';
        if (filtros !== '') {
            textoBusca = filtros.textoBusca;
        }
        const { direcao, itensPorPagina, ordernarPor, pagina } = paginacao;
        let url =
            baseUrl +
             '/buscar-por-numero-data' +
              '?codigo-fazenda=' + codigoFazenda +
              '&numero-nota-pesagem=' + textoBusca +
              '&data-inicio=' + dataInicio +
              '&data-fim=' + dataFim +
               '&pagina=' + pagina;

        if (direcao !== null && direcao !== undefined) {
            url += '&direcao=' + direcao;
        }

        if (itensPorPagina !== null && itensPorPagina !== undefined) {
            url += '&itens-por-pagina=' + itensPorPagina;
        }

        if (ordernarPor !== null && ordernarPor !== undefined) {
            url += '&ordenar-por=' + ordernarPor;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: 'Buscando Notas de Pesagem'
        });
    }
};
